module.exports = __webpack_public_path__ + "pc/img/swiper_logo_06.b6d02432.png";